// dateUtils.js

export const formatDate = (dateString) => {
    const date = new Date(dateString);
  
    // Get hours, minutes, and format AM/PM
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert to 12-hour format
  
    // Format day, month, and year
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()]; // Get month name
  
     // Return formatted date string with <br /> after AM/PM
  return (
    <>
      At {hours}:{minutes} {ampm}, On {day} {month}, {year}
    </>
  );
  };
  